import { CALL_API } from './../../middlewares/api';
import moment from 'moment';

const onLoadListaVeiculosIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_VEHICLES_UNIDADE',
    endpoint: 'unidade',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: "veiculos" }
    }
  }
});

const onLoadListaVeiculos = () => (dispatch, getState) => {
  const { fetching, errors = [] } = getState().unidade.veiculos;
  if (!fetching && !errors.length) {
    dispatch(onLoadListaVeiculosIfNeeded());
  }
};

const removeVehicle = value => ({
  [CALL_API]: {
    type: 'REMOVE_VEHICLE_UNIDADE',
    endpoint: 'unidade',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'veiculos', id: value.id }
    }
  },
  value
});

const addVehicle = value => ({
  [CALL_API]: {
    type: 'ADD_VEHICLE_UNIDADE',
    endpoint: 'unidade',
    authenticated: true,
    config: {
      method: 'POST',
      querystring: { type: 'veiculos' },
      body: value
    }
  },
  value
});

const onLoadListaMoradoresIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_MORADORES_UNIDADE',
    endpoint: 'unidade',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: "moradores" }
    }
  }
});

const onLoadListaMoradores = () => (dispatch, getState) => {
  const { fetching, errors = [] } = getState().unidade.moradores;
  if (!fetching && !errors.length) {
    dispatch(onLoadListaMoradoresIfNeeded());
  }
};

const desabilitaMorador = value => ({
  [CALL_API]: {
    type: 'DISABLE_MORADOR_UNIDADE',
    endpoint: 'unidade',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { type: 'moradores', id: value.id }
    }
  },
  value
});

const adicionaMorador = value => ({
  [CALL_API]: {
    type: 'ADD_MORADOR_UNIDADE',
    endpoint: 'unidade',
    authenticated: true,
    config: {
      method: 'POST',
      querystring: { type: 'moradores' },
      body: {
        ...value,
        ...(timezone => ({
          timezone,
          data_nascimento: moment(value.data_nascimento).utcOffset(timezone, true).format()
        }))(moment().format('Z'))
      }
    }
  },
  value
});

export default {
  onLoadListaVeiculos,
  removeVehicle,
  addVehicle,
  onLoadListaMoradores,
  desabilitaMorador,
  adicionaMorador,
  onLoadListaVeiculosIfNeeded,
  onLoadListaMoradoresIfNeeded
};


// WEBPACK FOOTER //
// ./src/modules/unidade/actions.js